import axios from "axios"
import config from "../config"
const BASE_URL = `${config?.apiUrl}`
const axiosInstant = axios.create({
  baseURL: BASE_URL,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
  },
})

axiosInstant.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  config.headers["Authorization"] = `Bearer ${token}`
  return config
})
axiosInstant.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
)
const API = {
  LOGIN: `/proxyclient/login`,
  GET_CURRENT_USER: `/proxyclient/getCurrentUser`,
  GET_CURRENT_USER_PERMISSIONS: `/proxyclient/getCurrentUserPermissions`,
  GET_ROLES: `/proxyclient/getRoles`,
  GET_MERCHANTS: `/proxyclient/getMerchants`,
  GET_OBJECTS_BY_PAGINATION: `/proxyclient/getObjectsByPagination`,
  QUERY_COMPRESS_OBJECTS: `/proxyclient/queryCompressObjects`,
  COUNT_OBJECTS_WITH_DATE_RANGE: `/proxyclient/countObjectsWithDateRange`,
  SUM_OBJECTS_WITH_DATE_RANGE: `/proxyclient/sumObjectsWithDateRange`,
  ADMIN_LOGGER: `/proxyclient/adminLogger`,
  GET_OBJECT_WITH_ID: `/proxyclient/getObjectWithId`,
  GET_ALL_OBJECTS: `/proxyclient/getAllObjects`,
  GET_ADMINS: `/proxyclient/getAdmins`,
  DESTROY_OBJECT_WITH_ID: `/proxyclient/destroyObjectWithId`,
  GET_CONFIG: `/proxyclient/getConfig`,
  SAVE_CONFIG: `/proxyclient/saveConfig`,
  CREATE_OBJECT: `/proxyclient/createObject`,
  GET_TRANSACTIONS: `/proxyclient/getTransactions`,
  AGGREGATE_SUM_BALANCE: `/proxyclient/aggregateSumBalance`,
  GET_BANKS: `/proxyclient/getBanks`,
  GET_CLIENTS: `/proxyclient/getClients`,
  AGGREGATE_BALANCE_V2: `/proxyclient/aggregateBalance_V2`,
  UPDATE_OBJECT: `/proxyclient/updateObject`,

  IP: `/user/ip`,
}

const logout = () => {
  localStorage.removeItem("token")
}

export const login = async (userInfo) => {
  try {
    const response = await axiosInstant.post(API.LOGIN, {
      userInfo,
      code: userInfo.code,
    })
    const user = response?.result?.user
    console.log("response :>> ", user)
    if (user?.roleId) {
      const res = await (await axiosInstant.get(API.IP))?.data
      console.log("res :>> ", res)
    }
    return response
  } catch (error) {
    console.error("Login error:", error)
    logout()
    throw error
  }
}

export const getCurrentUser = async () => {
  try {
    const response = await axiosInstant.get(API.GET_CURRENT_USER)
    return response?.result
  } catch (error) {
    console.error("Get current user error:", error)
    throw error
  }
}
export const getCurrentUserPermissions = async () => {
  const userId = localStorage.getItem("userId")
  try {
    const response = await axiosInstant.post(API.GET_CURRENT_USER_PERMISSIONS, {
      userId,
    })
    return response?.result?.permissionItems
  } catch (error) {
    console.error("Get current permission user error:", error)
    throw error
  }
}
export const getRoles = async (params) => {
  try {
    const response = await axiosInstant.post(API.GET_ROLES, params)
    return response?.result
  } catch (error) {
    console.error("Get roles error:", error)
    throw error
  }
}
export const getPermissionIndex = async (user) => {
  let currentUser = user
  if (!currentUser) {
    currentUser = await getCurrentUser()
  }
  const roleIndex = await (
    await getRoles({ objectId: currentUser?.roleId })
  ).roleIndex
  return roleIndex
}

export const getMerchants = async (params) => {
  try {
    const response = await axiosInstant.post(API.GET_MERCHANTS, params)
    return response?.result || []
  } catch (error) {
    console.error("Get merchants error:", error)
    throw error
  }
}

export const getObjectsByPagination = async (params) => {
  try {
    const response = await axiosInstant.post(
      API.GET_OBJECTS_BY_PAGINATION,
      params
    )
    return response
  } catch (error) {
    console.error("Get objects by pagination error:", error)
    throw error
  }
}
export const queryCompressObjects = async (className, params) => {
  try {
    const response = await axiosInstant.post(API.QUERY_COMPRESS_OBJECTS, {
      className,
      ...params,
    })
    return response?.results
  } catch (error) {
    console.error("Get objects by pagination error:", error)
    throw error
  }
}
export const countObjectsWithDateRange = async (params) => {
  try {
    const response = await axiosInstant.post(
      API.COUNT_OBJECTS_WITH_DATE_RANGE,
      {
        ...params,
      }
    )
    return response?.result
  } catch (error) {
    console.error("Get countObjectsWithDateRange error:", error)
    throw error
  }
}
export const sumObjectsWithDateRange = async (params) => {
  try {
    const response = await axiosInstant.post(API.SUM_OBJECTS_WITH_DATE_RANGE, {
      ...params,
    })
    return response?.result
  } catch (error) {
    console.error("Get sumObjectsWithDateRange error:", error)
    throw error
  }
}
export const adminLogger = async (type, activity, data) => {
  try {
    const response = await axiosInstant.post(API.ADMIN_LOGGER, {
      type,
      activity,
      data,
    })
    return response?.result
  } catch (error) {
    console.error("Admin logger error:", error)
    throw error
  }
}
export const getObjectWithId = async (className, objectId, options) => {
  try {
    const response = await axiosInstant.post(API.GET_OBJECT_WITH_ID, {
      className,
      objectId,
      options,
    })
    return response?.data
  } catch (error) {
    console.error("Get object with ID error:", error)
    throw error
  }
}

export const getAllObjects = async (params) => {
  try {
    const response = await axiosInstant.get(API.GET_ALL_OBJECTS, { params })
    return response?.data || []
  } catch (error) {
    console.error("Get all objects error:", error)
    throw error
  }
}

export const getAdmins = async (params) => {
  try {
    const response = await axiosInstant.post(API.GET_ADMINS, params)
    return response?.result || []
  } catch (error) {
    console.error("Get admins error:", error)
    throw error
  }
}

export const destroyObjectWithId = async (className, objectId) => {
  try {
    const response = await axiosInstant.post(API.DESTROY_OBJECT_WITH_ID, {
      className,
      objectId,
    })
    return response
  } catch (error) {
    console.error("Destroy object with ID error:", error)
    throw error
  }
}
export const getConfig = async () => {
  try {
    const response = await axiosInstant.get(API.GET_CONFIG)
    return response?.data
  } catch (error) {
    console.error("Get config error:", error)
    throw error
  }
}
export const createObject = async (className, data) => {
  try {
    const response = await axiosInstant.post(API.CREATE_OBJECT, {
      className,
      req: data,
    })
    return response?.result
  } catch (error) {
    console.error("Create object error:", error)
    throw error
  }
}
export const getTransactions = async (className, params) => {
  try {
    const response = await axiosInstant.post(API.GET_TRANSACTIONS, {
      className,
      props: params,
    })
    return response?.result || []
  } catch (error) {
    console.error("Get transactions error:", error)
    throw error
  }
}
export const aggregateSumBalance = async (params) => {
  try {
    const response = await axiosInstant.post(API.AGGREGATE_SUM_BALANCE, {
      ...params,
    })
    return response?.result || 0
  } catch (error) {
    console.error("Aggregate sum balance error:", error)
    throw error
  }
}
export const getBanks = async (params) => {
  try {
    const response = await axiosInstant.post(API.GET_BANKS, params)
    return response?.result
  } catch (error) {
    console.error("Get banks error:", error)
    throw error
  }
}

export const getClients = async (params) => {
  try {
    const response = await axiosInstant.post(API.GET_CLIENTS, params)
    return response?.result
  } catch (error) {
    console.error("Get clients error:", error)
    throw error
  }
}

export const aggregateBalance_V2 = async (params) => {
  try {
    const response = await axiosInstant.post(API.AGGREGATE_BALANCE_V2, {
      ...params,
    })
    return response?.result
  } catch (error) {
    console.error("Aggregate sum balance error:", error)
    throw error
  }
}
export const saveConfig = async (newConfig) => {
  try {
    const response = await axiosInstant.post(API.SAVE_CONFIG, {
      data: newConfig,
    })
    return response?.data
  } catch (error) {
    console.error("Save config error:", error)
    throw error
  }
}
export const updateObject = async (className, objectId, data) => {
  try {
    const response = await axiosInstant.post(API.UPDATE_OBJECT, {
      className,
      objectId,
      data,
    })
    return response?.data
  } catch (error) {
    console.error("Update object error:", error)
    throw error
  }
}
